import React from 'react'
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import { Label } from '@/components/ui/label'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select'
import { Switch } from '@/components/ui/switch'

interface ServicesAdvancedFiltersDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  featuredFilter: 'all' | 'featured' | 'standard'
  onFeaturedFilterChange: (value: 'all' | 'featured' | 'standard') => void
  footerFilter: 'all' | 'footer' | 'non-footer'
  onFooterFilterChange: (value: 'all' | 'footer' | 'non-footer') => void
  serviceAreasOnly: boolean
  onServiceAreasToggle: (value: boolean) => void
  seoAuditMode: boolean
  onSeoAuditToggle: (value: boolean) => void
  onDone: () => void
}

export function ServicesAdvancedFiltersDialog({
  open,
  onOpenChange,
  featuredFilter,
  onFeaturedFilterChange,
  footerFilter,
  onFooterFilterChange,
  serviceAreasOnly,
  onServiceAreasToggle,
  seoAuditMode,
  onSeoAuditToggle,
  onDone,
}: ServicesAdvancedFiltersDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-lg">
        <DialogHeader>
          <DialogTitle>Advanced Filters</DialogTitle>
        </DialogHeader>
        <div className="space-y-6">
          <div className="space-y-2">
            <Label>Featured Services</Label>
            <Select value={featuredFilter} onValueChange={(value) => onFeaturedFilterChange(value as typeof featuredFilter)}>
              <SelectTrigger>
                <SelectValue placeholder="All services" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="all">All services</SelectItem>
                <SelectItem value="featured">Featured only</SelectItem>
                <SelectItem value="standard">Exclude featured</SelectItem>
              </SelectContent>
            </Select>
          </div>

          <div className="space-y-2">
            <Label>Footer Navigation</Label>
            <Select value={footerFilter} onValueChange={(value) => onFooterFilterChange(value as typeof footerFilter)}>
              <SelectTrigger>
                <SelectValue placeholder="All services" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="all">All services</SelectItem>
                <SelectItem value="footer">Footer services only</SelectItem>
                <SelectItem value="non-footer">Hide footer services</SelectItem>
              </SelectContent>
            </Select>
          </div>

          <div className="space-y-4">
            <div className="flex items-center justify-between">
              <div>
                <Label>Service Areas</Label>
                <p className="text-sm text-muted-foreground">Show services with configured service areas</p>
              </div>
              <Switch checked={serviceAreasOnly} onCheckedChange={onServiceAreasToggle} />
            </div>
            <div className="flex items-center justify-between">
              <div>
                <Label>SEO Audit Mode</Label>
                <p className="text-sm text-muted-foreground">Highlight services that need SEO attention</p>
              </div>
              <Switch checked={seoAuditMode} onCheckedChange={onSeoAuditToggle} />
            </div>
          </div>

          <div className="flex justify-end gap-2">
            <Button variant="outline" onClick={() => onOpenChange(false)}>
              Cancel
            </Button>
            <Button onClick={onDone}>Done</Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  )
}
